import { Enum, EnumType } from 'ts-jenum';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faComments, faEnvelope, faPhone, faQuestion } from '@fortawesome/pro-solid-svg-icons';
import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons';
import _ from 'lodash';

@Enum<Sccs1ConversationType>('value')
export class Sccs1ConversationType extends EnumType<Sccs1ConversationType>() {
   static readonly Unknown = new Sccs1ConversationType('None', 0, faQuestion);
   static readonly Call = new Sccs1ConversationType('Call', 1, faPhone);
   static readonly Email = new Sccs1ConversationType('Email', 2, faEnvelope);
   static readonly Webchat = new Sccs1ConversationType('Webchat', 3, faComments);
   static readonly Facebook = new Sccs1ConversationType('Facebook', 4, faFacebook);
   static readonly Twitter = new Sccs1ConversationType('Twitter', 5, faTwitter);
   static readonly RocketChat = new Sccs1ConversationType('RocketChat', 6, faComments);

   private constructor(public value: string, public samwinValue: number, public icon: IconDefinition) {
      super();
   }

   public static valueBySamwinValue(samwinValue: number): Sccs1ConversationType {
      return _(Sccs1ConversationType.values()).find((x) => x.samwinValue === samwinValue);
   }
}
